import uiRouter from 'angular-ui-router';
import { UButtonGroupComponent } from '@updater/angular-common';
import { HudsonInsuranceConfig } from './hudson-insurance.config';
import { HudsonInsuranceComponent } from './hudson-insurance.component';
import { SuccessModalComponent } from './success-modal';
import {
  StepPageModule,
  UCloudinaryImageDirectives,
} from '../../common/directives';

export const HudsonInsuranceStepModule = angular
  .module('app.steps.hudson-insurance', [
    uiRouter,
    StepPageModule.name,
    UButtonGroupComponent.name,
    UCloudinaryImageDirectives.name,
  ])
  .config(HudsonInsuranceConfig)
  .component('updHudsonInsurance', HudsonInsuranceComponent)
  .component('updHudsonInsuranceSuccessModal', SuccessModalComponent);
